import axios from '../api-axios'
import encode from 'strict-uri-encode'

export default {
  fetchApprovedEvents(id) {
    return axios.get(`/events?installation=${encode(id)}&approved=1`)
  },
  fetchEventDetails(id) {
    return axios.get(`/events/${encode(id)}`)
  },
  fetchEventImages(id) {
    return axios.get(`/events/${encode(id)}/images`)
  },
  putEvent(model) {
    return axios.put(`/events/${encode(model.eventId)}`, model)
  }
}
